import React from "react";
import { useIntl } from "react-intl";
import { object, number } from "yup";
import { Form, Grid, Space } from "@masterteam/mt-design-react";

import "./style.scss";

const { Row, Col } = Grid;
const { Field } = Form;

export const escalationValidationSchema = object().shape({
  BeforeReminder: number().required(" ").min(0, " "),
  FirstReminder: number().required(" ").min(0, " "),
  SecondReminder: number().required(" ").min(0, " ")
});

function EscalationsTab({ readOnly, formBag }) {
  const intl = useIntl();
  const { errors } = formBag;

  return (
    <Space
      direction="vertical"
      size="large"
      className="kpi-config__form__escalations"
    >
      <Row>
        <div className="kpi-config__form__escalations__title">
          {intl.formatMessage({ id: "kpi-type.in-case-no-update" })}
        </div>
      </Row>
      <Row>
        <Col span={8}>
          <Space align="center" className="control">
            <Field
              label={intl.formatMessage({ id: "kpi-type.before" })}
              name="BeforeReminder"
              type="number"
              disabled={readOnly}
              inputProps={{
                onKeyDown: (evt) => {
                  if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                    evt.preventDefault();
                  }
                },
                min: 0,
                error: errors?.BeforeReminder
              }}
            />
            <div className="control__days">
              {intl.formatMessage({ id: "common.days" })}
            </div>
          </Space>
        </Col>
        <Col span={8}>
          <Space align="center" className="control">
            <Field
              label={intl.formatMessage({ id: "kpi-type.first-reminder" })}
              name="FirstReminder"
              type="number"
              disabled={readOnly}
              inputProps={{
                onKeyDown: (evt) => {
                  if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                    evt.preventDefault();
                  }
                },
                min: 0,
                error: errors?.FirstReminder
              }}
            />
            <div className="control__days">
              {intl.formatMessage({ id: "common.days" })}
            </div>
          </Space>
        </Col>
        <Col span={8}>
          <Space align="center" className="control">
            <Field
              label={intl.formatMessage({ id: "kpi-type.second-reminder" })}
              name="SecondReminder"
              type="number"
              disabled={readOnly}
              inputProps={{
                onKeyDown: (evt) => {
                  if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                    evt.preventDefault();
                  }
                },
                min: 0,
                error: errors?.SecondReminder
              }}
            />
            <div className="control__days">
              {intl.formatMessage({ id: "common.days" })}
            </div>
          </Space>
        </Col>
      </Row>
    </Space>
  );
}

export default EscalationsTab;
